import React from 'react';
import Login from '../../components/login'
import './style.css'

const signin = () => {
  return (
    <div className="form-login">
      <Login/> 
    </div>
  );
};

export default signin;